import _ from 'lodash'
import { ItListItem } from 'types/graphql'

import PromoCodeButton from './PromoCodeButton/PromoCodeButton'
import { PromoCodeEditor } from './PromoCodeEditor/PromoCodeEditor'
import usePromoCode from './usePromoCode'

const PromoCode = ({ item }: { item: ItListItem }) => {
  const { showPromoCodeEditor, setShowPromoCodeEditor, allowPromoCode } =
    usePromoCode(item)

  return showPromoCodeEditor ? (
    <PromoCodeEditor
      close={() => setShowPromoCodeEditor(false)}
      name={item.type}
    />
  ) : (
    <PromoCodeButton
      isDisabled={!allowPromoCode}
      onClick={() => setShowPromoCodeEditor(true)}
      testid="promoCode-button"
    />
  )
}

export default PromoCode
